"use client";
import React from "react";
import { usePathname } from "next/navigation";
import GlobalHeader from "./GlobalHeader";
import AuthClientRoot from "./AuthClientRoot";
import ImpersonationIndicator from "./ImpersonationIndicator";
import SiteAutoAds from "./SiteAutoAds";

export default function RootLayoutContent({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (pathname.startsWith("/bihar/school-maps")) {
    return <>{children}</>;
  }
  if (pathname.startsWith("/ghackk-admin")) {
    return <AuthClientRoot>{children}</AuthClientRoot>;
  }
  if (pathname.startsWith("/dashboard")) {
    return <AuthClientRoot>{children}</AuthClientRoot>;
  }
  return (
    <AuthClientRoot>
      <ImpersonationIndicator />
      <GlobalHeader />
      <SiteAutoAds />
      {children}
    </AuthClientRoot>
  );
} 